<template>
  <div>
    <h2 class="page-title">
      <img
        :src="require(`@images/result/${$route.params.lang}/txt_result.png`)"
        class="page-title-text"
      >
    </h2>
    <p class="result-text" v-html="$t('text002', heroNames, 'localeResult')" />
    <div class="result-stand-heroes-wrapper">
      <p class="result-stand-heading" v-html="$t('text003', null, 'localeResult')" />
      <div class="result-stand-heroes">
        <div v-for="(i) in 2" :key="i" class="rank-container" :class="[`rank${i}`]">
          <hero-stand
            v-for="(item, i) in rankHero(i)"
            :key="i"
            :hero="item"
            :class="`${(i+1)%2 == 0 ? '-even' : '-odd'}`"
          />
        </div>
      </div>
    </div>

    <div class="line" />

    <div class="result-heroes-wrapper">
      <div class="result-heading">
        <p v-html="$t('text004', null, 'localeResult')" />
        <p v-html="$t('text005', null, 'localeResult')" />
      </div>
      <div class="result-heroes">
        <div v-for="(i) in 8" :key="i" class="rank-container" :class="[`rank${i+2}`]">
          <hero
            v-for="(item, i) in rankHero(i+2)"
            :key="i"
            :hero="item"
          />
        </div>
      </div>
    </div>

    <div class="result-ranking-wrapper">
      <p v-html="$t('text006', null, 'localeResult')" />
      <div class="result-ranking">
        <div class="result-ranking-item"><span v-html="$t('text007', null, 'localeResult')" @click="goToResultDetail(1)" /></div>
        <div class="result-ranking-item"><span v-html="$t('text008', null, 'localeResult')" @click="goToResultDetail(2)" /></div>
        <div class="result-ranking-item"><span v-html="$t('text009', null, 'localeResult')" @click="goToResultDetail(3)" /></div>
        <div class="result-ranking-item"><span v-html="$t('text010', null, 'localeResult')" @click="goToResultDetail(4)" /></div>
      </div>
    </div>

    <div class="line" />

    <btn-official />

    <app-download class="app-download" />
    <div class="bg-footer">
      <sns-share share-text="footer.share.result" :replace-text="replaceText">
        <img :src="require(`@images/sns-share/${$route.params.lang}/text_share.png`)" />
      </sns-share>
      <trademark />
    </div>
  </div>
</template>

<script>
import maleRanking from '@constants/male-ranking'
import femaleRanking from '@constants/female-ranking'
import store from '@/store/index'

import HeroStand from '@components/result/hero-stand'
import Hero from '@components/result/hero'
import BtnOfficial from '@components/global/button-official.vue'
import AppDownload from '@components/global/app-download.vue'
import SnsShare from '@components/global/sns-share.vue'
import Trademark from '@components/global/trademark.vue'

import localeResult from '@locales/result'
import localeCharacter from '@locales/character'

export default {
  name: 'results',
  beforeRouteEnter (to, from, next) {
    if (store.getters['menu/termType'] === 3) {
      next()
    } else {
      next('/')
    }
  },
  $messages: { localeResult, localeCharacter },
  components: {
    HeroStand,
    Hero,
    BtnOfficial,
    AppDownload,
    SnsShare,
    Trademark,
  },
  computed: {
    replaceText() {
      return { url: `${location.origin}/${this.$route.params.lang}/results` }
    },
    heroNames() {
      return {
        no1_man_name: this.$t(maleRanking[0].heroId, null, 'localeCharacter'),
        no2_man_name: this.$t(maleRanking[1].heroId, null, 'localeCharacter'),
        no1_woman_name: this.$t(femaleRanking[0].heroId, null, 'localeCharacter'),
        no2_woman_name: this.$t(femaleRanking[1].heroId, null, 'localeCharacter'),
      }
    }
  },
  methods: {
    goToResultDetail(page){
      this.$router.push(`/${this.$route.params.lang}/results/${page}`)
      window.scrollTo(0, 0)
    },
    rankHero(rank){
      const male = maleRanking.filter((r => Number(r.rank) === Number(rank)))
      const female = femaleRanking.filter((r => Number(r.rank) === Number(rank)))
      return male.concat(female)
    },
  }
}
</script>

<style lang="scss" scoped>
.page-title {
  background-image: url(~@images/bg_page-title.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  height: 60px;
  width: 608px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  &-text {
    margin-top: -8px;
  }
}
.result-text {
  font-size: $fs-xlarge;
  text-shadow: $ts-base;
  text-align: center;
  margin-top: 20px;
}
.result-stand-heading {
  text-align: center;
  text-shadow: $ts-base;
  font-size: $fs-xlarge;
  margin-bottom: 40px;
}
.result-heading {
  display: flex;
  justify-content: space-around;
  font-weight: 600;
}
.result-stand-heroes-wrapper,
.result-heroes-wrapper {
  margin: 40px auto 0;
  width: 100%;
}
.result-stand-heroes,
.result-heroes {
  .rank-container {
    display: flex;
    margin-bottom: 110px;
    > .-even /deep/ .description {
      left: 0;
    }
  }
}
.result-heroes {
  margin-top: 20px;
}
.line {
  height: 2px;
  margin: 0;
  background-image: url(~@images/common/line.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 2px;
  border: 0;
}
.result-ranking-wrapper {
  text-align: center;
}
.result-ranking {
  background-image: url(~@images/result/bg_result-ranking.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 10px auto 20px;
  width: 498px;
  height: 136px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 40px;
  &-item {
    width: 50%;
    > span {
      text-decoration: underline;
      @include tap-event();
    }
  }
}
.bg-footer {
  background-color: rgba(0, 0, 0, .5);
}
.sns-share {
  margin-top: 20px;
}
</style>
